module.exports = __webpack_public_path__ + "img/reminder.46ce06ba.jpg";